import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getProfile = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getProfile, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const makeDefault = async (profileId: string) => {
  const url = `${urls.makeDefault}/${profileId}/default`;
  try {
    const callParams = await getCallParams("PUT");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const contactUs = async (reason: string, message: string) => {
  const obj = {
    reason,
    message,
  };
  try {
    const callParams = await getCallParams("POST", obj);
    const response = await makeCall(urls.contactUsApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const setNotificationsToken = async (token: string | any) => {
  try {
    const callParams = await getCallParams("POST", { token });
    const response = await makeCall(urls.notificationList, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
